import { useEffect } from 'react';
import { getLastPhaseStep } from '../../shared/utils/phase';
import { getOrdersProductData } from '../../shared/utils/ordersProductData';
import { TOASTR_TYPE_ERROR, TOASTR_TYPE_SUCCESS } from '../../../../../utils/toastr';
import { postData } from '../../../../../utils/async';
import { uiBlocker } from '../../../../../library/ui-blocker/ui-blocker';
import { customToastr } from '../../../../../library/toastr/toastr';

const uiBlock = uiBlocker();

// Logika kalkulačky => přechod mezi kroky a fázemi
export const useCalculationNextStep = (
    savedProducts,
    isDietModeAndLastPhaseAndLastPhaseStep,
    isPhaseModeAndLastPhaseStep,
    isDietModeAndLastPhaseStep,
    setNextPhase,
    setNextPhaseStep,
    resetPhaseStep,
    resetPickedProducts,
    phaseStepLimit,
    phaseStep,
    isDietModeAndLastPhase,
    isPhaseMode,
    saveProductApiEndpoint,
    dietId,
    activePhase,
    cartLink,
    removeProductsFromStorage,
    cartItemId,
    phaseIds,
    loadAllProductsFromStorage
) => {
    // Odeslání objednávky (aktuálně z sideEffektu uložení produktů)
    const sendOrder = () => {
        const dietCalculationSendOfferButtons = document.getElementsByClassName('diet-calculation-send-offer');
        const phaseId = activePhase.id;
        const products = loadAllProductsFromStorage(cartItemId, dietId, phaseIds);
        const pickedProducts = getOrdersProductData(isDietModeAndLastPhase, products, phaseId);
        const data = {
            phaseId,
            dietId,
            pickedProducts,
        };

        const hasSendButtons = dietCalculationSendOfferButtons && dietCalculationSendOfferButtons.length > 0;

        if (hasSendButtons) {
            for (const dietCalculationSendOfferButton of dietCalculationSendOfferButtons) {
                uiBlock.block(dietCalculationSendOfferButton);
            }
        }

        postData(saveProductApiEndpoint, data)
            .then((data) => {
                if (hasSendButtons) {
                    for (const dietCalculationSendOfferButton of dietCalculationSendOfferButtons) {
                        uiBlock.unblock(dietCalculationSendOfferButton);
                    }
                }
                if (data.error) {
                    customToastr(TOASTR_TYPE_ERROR, data.message);
                } else {
                    customToastr(TOASTR_TYPE_SUCCESS, data.message);
                    window.location.href = cartLink;
                    removeProductsFromStorage(cartItemId, dietId, phaseIds);
                }
            })
            .catch((error) => {
                if (hasSendButtons) {
                    for (const dietCalculationSendOfferButton of dietCalculationSendOfferButtons) {
                        uiBlock.unblock(dietCalculationSendOfferButton);
                    }
                }
                customToastr(TOASTR_TYPE_ERROR, error);
            });
    };

    // Přechod na další krok fáze, pokud byl poslední a jedná se o dietu, přejdeme na první krok následující fáze
    useEffect(() => {
        if (savedProducts === null) {
            return;
        }

        if (isDietModeAndLastPhaseAndLastPhaseStep || isPhaseModeAndLastPhaseStep) {
            sendOrder();
            return;
        }
        if (isDietModeAndLastPhaseStep) {
            setNextPhase();
            resetPhaseStep();
        } else {
            setNextPhaseStep();
        }

        resetPickedProducts();
    }, [savedProducts]);

    // Potřebujeme kotrolovat, zdali se krok fáze skládá alespoň z jednoho produktů (phaseStepLimit) => přeskočíme
    useEffect(() => {
        if (phaseStepLimit === 0) {
            if (phaseStep === getLastPhaseStep(activePhase)) {
                if (isDietModeAndLastPhase || isPhaseMode) {
                    sendOrder();
                } else {
                    setNextPhase();
                    resetPhaseStep();
                }
            } else {
                setNextPhaseStep();
            }
        }
    }, [phaseStepLimit, phaseStep, isDietModeAndLastPhase]);
};
